






































import Vue from "vue";
import CenterLayout from "@/components/CenterLayout.vue";
import UtdsHeader from "@/components/utds/UtdsHeader.vue";
import { spotifyCredentials } from "@/globalVariables";
import { SpotifyTokenResponse } from "@/structures/spotifyApi";
import { StoreActions } from "@/structures/store";

export default Vue.extend({
    components: { CenterLayout, UtdsHeader },
    mounted() {
        if (this.$store.state.accessToken !== "") {
            this.$router.push({ name: "Controller" });
        }

        let queryParameters = new URLSearchParams(window.location.search);
        if (queryParameters.get("code")) {
            this.getOAuthTokens(queryParameters);
        }
    },
    methods: {
        startAuthorizationFlow(): void {
            let baseURL = "https://accounts.spotify.com/authorize";
            let url = `${baseURL}?client_id=${
                spotifyCredentials.clientId
            }&response_type=code&redirect_uri=${encodeURIComponent(
                spotifyCredentials.redirectUri
            )}&scope=${encodeURIComponent(
                spotifyCredentials.scopes.join(" ")
            )}`;

            window.open(url, "_self");
        },
        getOAuthTokens(queryParameters: URLSearchParams): void {
            if (queryParameters.get("code")) {
                let tokenParameters = new URLSearchParams({
                    grant_type: "authorization_code",
                    code: queryParameters.get("code") || "",
                    redirect_uri: spotifyCredentials.redirectUri,
                });

                fetch(`https://accounts.spotify.com/api/token`, {
                    method: "POST",
                    headers: {
                        Authorization: `Basic ${btoa(
                            spotifyCredentials.clientId +
                                ":" +
                                spotifyCredentials.clientSecret
                        )}`,
                        "Content-Type": "application/x-www-form-urlencoded",
                    },
                    body: tokenParameters,
                })
                    .then((response) => response.json())
                    .then((json) => this.storeSpotifyCredentials(json))
                    .catch((error) => {
                        if (error.response) {
                            if (
                                error.response.data.error_description.indexOf(
                                    "Invalid authorization code"
                                ) != -1
                            ) {
                                this.startAuthorizationFlow();
                            } else {
                                console.error(error);
                            }
                        } else {
                            console.error(error);
                        }
                    });
            }
        },
        storeSpotifyCredentials(
            spotifyTokenResponse: SpotifyTokenResponse
        ): void {
            this.$store.dispatch(StoreActions.SET_CREDENTIALS, {
                accessToken: spotifyTokenResponse.access_token,
                refreshToken: spotifyTokenResponse.refresh_token,
                expiresIn: spotifyTokenResponse.expires_in,
            });

            this.$router.push({ name: "Controller" });
        },
    },
});
